import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniahireforpicnicinpune() {



  const cardData = {
"keyword": "Urbania Hire for Picnic in Pune",

"headingDescription":
  "Shivai Travels offers comfortable and reliable Urbania hire for picnic in Pune, perfect for family outings, corporate picnics, school trips, weekend getaways, and group tours across Maharashtra. Our Force Urbania rental service is designed for premium group travel with spacious seating, pushback reclining seats, powerful air conditioning, smooth suspension, charging points, music system, and ample luggage space to ensure a relaxed and enjoyable journey. Whether you are planning a one-day picnic near Pune or an outstation group excursion, Shivai Travels provides experienced drivers, well-maintained vehicles, and safe highway travel for a hassle-free experience. Ideal for groups of 15–17 passengers, our Urbania hire service includes flexible packages such as local picnic rentals, half-day and full-day bookings, outstation trips, customized tour plans, doorstep pickup and drop, and 24/7 customer support, making it a perfect choice for comfortable group picnic travel from Pune.",

"topPlaces": [
 
  {
    "title": "Pawna Lake",
    "description":
      "Pawna Lake is a popular camping and picnic destination near Lonavala known for lakeside views, camping activities, bonfire spots, and sunset scenery, ideal for group travel."
  },
  {
    "title": "Mulshi Dam",
    "description":
      "Mulshi Dam is a scenic location near Pune surrounded by Sahyadri hills and lush greenery, making it a favorite spot for peaceful picnic trips and nature outings."
  },
   {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular picnic spots near Pune, known for waterfalls, green valleys, forts, and scenic viewpoints, making them perfect for Urbania group picnic trips."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city near Pune famous for its lakeside promenade, European-style architecture, and peaceful atmosphere, ideal for one-day group picnic outings."
  },
  {
    "title": "Khadakwasla Dam",
    "description":
      "Khadakwasla Dam is a quick picnic getaway near Pune famous for water views, street food, and sunset points, perfect for short group outings and half-day trips."
  },
  {
    "title": "Sinhagad Fort",
    "description":
      "Sinhagad Fort is a historic fort near Pune offering trekking, panoramic views, and local food stalls, making it a popular adventure picnic destination for groups."
  },
  {
    "title": "Tamhini Ghat",
    "description":
      "Tamhini Ghat is a scenic monsoon route near Pune known for waterfalls, misty valleys, and lush greenery, ideal for group road trip picnics in Urbania vehicles."
  },
  {
    "title": "Aga Khan Palace Area & Pune City Spots",
    "description":
      "Pune city picnic circuits including Aga Khan Palace surroundings, gardens, and cultural spots are ideal for short group tours and educational picnic trips."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a popular hill station for extended picnic trips from Pune, known for viewpoints, strawberries, cool climate, and scenic road journeys."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal picnic destination near Mumbai famous for beaches, forts, and resorts, making it ideal for weekend group picnics from Pune."
  }
],



services: [
  {
    name: "Urbania Picnic Rental Pune",
    description: "Urbania picnic rental Pune service provides premium and spacious transportation for family outings, group picnics, corporate tours, sightseeing trips, and one-day travel plans. Luxury Force Urbania vehicles with experienced drivers ensure smooth and safe travel for local and outstation picnic routes. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Vehicles offer pushback seating, air conditioning, premium interiors, and luggage space suitable for comfortable picnic travel. Flexible booking options allow convenient Urbania picnic rental reservations in Pune."
  },
  {
    name: "Picnic Urbania Hire Pune",
    description: "Picnic Urbania hire Pune service offers dependable transportation solutions for travelers planning outings and picnic trips from Pune. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, school trips, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient picnic Urbania hire reservations."
  },
  {
    name: "Family Picnic Urbania Pune",
    description: "Family picnic Urbania Pune service provides affordable and comfortable luxury travel options for families and groups planning picnic journeys. Travelers can enjoy smooth trips with experienced drivers familiar with tourist destinations, picnic spots, and highway routes. Vehicles ensure spacious seating and safe transportation suitable for family vacations, sightseeing tours, and one-day outings. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient family picnic Urbania reservations."
  },
  {
    name: "Urbania for Outing Pune",
    description: "Urbania for outing Pune service provides high-end transportation for passengers seeking comfortable and stylish group travel for outings and tours. Vehicles offer spacious seating, premium interiors, luggage capacity, and smooth ride quality suitable for tourism, corporate events, and leisure travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient outing Urbania reservations."
  },
  {
    name: "Group Picnic Urbania Pune",
    description: "Group picnic Urbania Pune service offers economical and comfortable luxury transportation for groups traveling within Pune and nearby destinations. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, picnic outings, and group travel. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient group picnic Urbania reservations."
  },
  {
    name: "Cheap Urbania Picnic Pune",
    description: "Cheap Urbania picnic Pune service provides comfortable transportation for families, corporate teams, and tourists traveling for picnic outings and local tours. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, group outings, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient affordable Urbania picnic reservations."
  },
  {
    name: "Luxury Urbania Picnic Hire Pune",
    description: "Luxury Urbania picnic hire Pune service offers spacious transportation for groups traveling for family tours, corporate outings, school trips, and sightseeing journeys. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance and local picnic travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury Urbania picnic reservations."
  },
  {
    name: "Pune Urbania Picnic Booking",
    description: "Pune Urbania picnic booking service provides reliable transportation for picnic pickup and drop services from Pune and nearby locations. Vehicles offer spacious seating, luggage space, and comfortable travel suitable for local and outstation picnic journeys. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Urbania picnic booking reservations."
  },
  {
    name: "Urbania Cab for Picnic Pune",
    description: "Urbania cab for picnic Pune service provides dependable transportation for group travel from Pune to tourist destinations, resorts, picnic spots, and hill stations. Comfortable vehicles ensure smooth highway travel suitable for tourism, corporate tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient Urbania picnic cab reservations."
  },
  {
    name: "Urbania One Day Picnic Pune",
    description: "Urbania one day picnic Pune service offers spacious and comfortable transportation for one-day travel plans from Pune to nearby sightseeing and picnic destinations. Vehicles provide comfortable seating and luggage space suitable for family groups, business teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one day picnic Urbania reservations."
  },
  {
    name: "Best Urbania Picnic Service Pune",
    description: "Best Urbania picnic service Pune offers premium transportation for sightseeing tours, family vacations, picnic journeys, and business travel with return options. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and corporate outings. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient best Urbania picnic service reservations."
  },
  {
    name: "AC Urbania Picnic Pune",
    description: "AC Urbania picnic Pune service offers reliable group transportation for picnic pickup and drop services, sightseeing tours, and outstation travel. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient AC Urbania picnic reservations."
  },
  {
    name: "Urbania with Driver Picnic Pune",
    description: "Urbania with driver picnic Pune service provides complete luxury transportation solutions for local and outstation picnic travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, group outings, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Urbania with driver picnic reservations."
  },
  {
    name: "Outstation Picnic Urbania Pune",
    description: "Outstation picnic Urbania Pune service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for group tours, family trips, sightseeing tours, corporate outings, and long-distance picnic travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation picnic Urbania reservations."
  },
  {
    name: "Pune Picnic Travel Urbania",
    description: "Pune picnic travel Urbania service provides luxury transportation for groups looking for premium travel experiences with spacious seating and comfortable interiors. Vehicles are suitable for corporate events, destination outings, sightseeing trips, and family picnic tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient picnic travel Urbania reservations."
  }
],

tableData: [
  ["Urbania Picnic Rental Pune", "Picnic Urbania Hire Pune"],
  ["Family Picnic Urbania Pune", "Urbania for Outing Pune"],
  ["Group Picnic Urbania Pune", "Cheap Urbania Picnic Pune"],
  ["Luxury Urbania Picnic Hire Pune", "Pune Urbania Picnic Booking"],
  ["Urbania Cab for Picnic Pune", "Urbania One Day Picnic Pune"],
  ["Best Urbania Picnic Service Pune", "AC Urbania Picnic Pune"],
  ["Urbania with Driver Picnic Pune", "Outstation Picnic Urbania Pune"],
  ["Pune Picnic Travel Urbania", "Urbania Picnic Rental Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Urbania Hire for Picnic in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Urbania hire for picnic trips in Pune with professional drivers, luxury seating, and punctual pickup for smooth and enjoyable group travel experiences."
      },
      {
        WhyChooseheading: "Affordable Urbania Picnic Rental Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Urbania hire for picnic travel in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Urbania Picnic Vehicle Availability",
        WhyChoosedescription: "Our Urbania hire service in Pune operates 24 hours a day for family picnics, corporate outings, school trips, weekend getaways, and group travel requirements."
      },
      {
        WhyChooseheading: "Luxury & Comfortable AC Urbania Vehicles",
        WhyChoosedescription: "All Urbania vehicles provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide premium comfort during picnic and sightseeing journeys."
      },
      {
        WhyChooseheading: "One Day & Weekend Picnic Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-day picnic packages, weekend getaway travel, local sightseeing, and customized Urbania tour packages from Pune."
      },
      {
        WhyChooseheading: "Perfect Vehicle for Group Picnic Travel",
        WhyChoosedescription: "Our Urbania vehicles are ideal for family groups, friends, corporate teams, school students, and tourists with spacious seating, luggage capacity, and luxury interiors for comfortable picnic travel."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, schools, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Picnic Destinations",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune picnic spots, hill stations, resorts, Konkan roads, and nearby tourist destinations, ensuring safe driving and smooth travel for every group outing."
      }
    ]
  };

  const faqData = [
    { question: "What is Urbania hire for picnic in Pune?", answer: "Urbania hire for picnic in Pune provides luxury group transportation for family outings, corporate picnics, school trips, sightseeing tours, and weekend getaways." },
    { question: "Is Urbania hire for picnic in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Urbania hire service for picnic and group travel in Pune." },
    { question: "Which Urbania seating options are available for picnic trips?", answer: "Shivai Travels offers 10 seater, 13 seater, and 17 seater Urbania vehicles for picnic travel." },
    { question: "Can I book Urbania for one-day picnic trips?", answer: "Yes, customers can book Urbania vehicles for one-day picnics, weekend trips, sightseeing tours, and outstation travel." },
    { question: "Do you provide one-way and round-trip Urbania picnic service?", answer: "Yes, Shivai Travels provides both one-way and round-trip Urbania booking services for picnic travel." },
    { question: "Are all Urbania vehicles air-conditioned?", answer: "Yes, all Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book Urbania hire for picnic in Pune online?", answer: "Yes, customers can easily book Urbania picnic rental service online or through phone booking." },
    { question: "Do you provide Urbania vehicles for school and corporate picnics?", answer: "Yes, Shivai Travels provides Urbania vehicles for school trips, corporate outings, family gatherings, and group picnic travel." },
    { question: "Are Urbania picnic rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Urbania picnic hire in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, picnic seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akshay Kulkarni",
      feedback:
        "Booked Urbania hire for picnic in Pune with Shivai Travels. Luxury vehicle, smooth journey, and excellent driver support for our family outing.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Patil",
      feedback:
        "Excellent Urbania rental service for picnic trips in Pune. Affordable pricing, clean luxury vehicle, and wonderful group travel experience.",
      rating: 5
    }
  ];






  

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Picnic in Pune",
  "image": "https://shivaitravels.com/assets/images/urbania-picnic-pune.jpg",
  "description": "Book Urbania hire for picnic in Pune with Shivai Travels for comfortable, spacious and luxury group travel. Ideal for family picnics, one-day outings, group tours, and outstation picnic trips. Available with AC, professional driver, and flexible booking options including one-way and round-trip.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹25/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/urbania-picnic-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>Urbania Hire for Picnic in Pune | Family & Group Picnic Cab | Shivai Travels | +91 9689815477</title>

  <meta
    name="description"
    content="Book Urbania for picnic in Pune with Shivai Travels. Spacious and luxury Urbania cab for family picnics, group outings, one-day trips, and outstation travel. Available with driver and AC comfort 24x7."
  />

  <meta
    name="keywords"
    content="urbania picnic rental pune, picnic urbania hire pune, family picnic urbania pune, urbania for outing pune, group picnic urbania pune, cheap urbania picnic pune, luxury urbania picnic hire pune, pune urbania picnic booking, urbania cab for picnic pune, urbania one day picnic pune, best urbania picnic service pune, ac urbania picnic pune, urbania with driver picnic pune, outstation picnic urbania pune, pune picnic travel urbania"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniahireforpicnicinpune;